import { Flex } from '@chakra-ui/react';
import moment from 'moment';
import { FaChevronCircleRight } from 'react-icons/fa';

import { Txt } from '@app/components/common';
import { TableColumn } from '@app/components/common/table';
import { USER_DATE_TIME_FORMAT } from '@app/utils';
import { TransactionInfo, TransactionPackageDetail } from '@app/api/models/transaction';

import { Status } from './components/status';
import { TxTypeView } from './components/tx-type';
import { OutletColumn } from '../components/outlet-column';

export const useTransactionColumns = (): TableColumn<TransactionInfo>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string) => {
          return <Flex gap={2}>
            <Txt fontSize='sm' textColor='gray.500'>{value}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'equip',
      label: 'ХО',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          if (!rowData.equip?.model?.name) {
            return <Txt fontSize='sm' textColor='gray.500'>не указано</Txt>;
          }
          return <Flex gap={2}>
            <Txt fontSize='sm' >{rowData.equip?.model?.name}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'equip',
      label: 'Серийный номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          if (!rowData.equip?.serial_num) {
            return <Txt fontSize='sm' textColor='gray.500'>не указано</Txt>;
          }
          return <Flex gap={2}>
            <Txt fontSize='sm' >{rowData.equip?.serial_num}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'equip',
      label: 'Инвентарный номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          if (!rowData.equip?.inventory_num) {
            return <Txt fontSize='sm' textColor='gray.500'>не указано</Txt>;
          }
          return <Flex gap={2}>
            <Txt fontSize='sm' >{rowData.equip?.inventory_num}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'distributor',
      label: 'Дистрибьютор',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          if (!rowData.distributor?.name) {
            return <Txt fontSize='sm' textColor='gray.500'>не указано</Txt>;
          }
          return <Flex gap={2}>
            <Txt fontSize='sm' >{rowData.distributor?.name}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'outlet_from',
      label: 'ТТ отправки',
      options: {
        filter: false,
        sort: false,
        customBodyRender: OutletColumn
      }
    },
    {
      name: 'outlet_to',
      label: 'ТТ назначения',
      options: {
        filter: false,
        sort: false,
        customBodyRender: OutletColumn
      }
    },
  ];
};